var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNti(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4631 22.389C22.5091 23.472 21.3476 24.3581 20.0402 25.0005V28.6924C20.0402 29.0188 19.91 29.3318 19.6783 29.5626C19.4465 29.7934 19.1322 29.923 18.8045 29.923H11.3902C11.0625 29.923 10.7482 29.7934 10.5165 29.5626C10.2847 29.3318 10.1545 29.0188 10.1545 28.6924V25.0005C7.5505 23.706 5.55976 21.4465 4.60951 18.7069C3.65925 15.9673 3.82521 12.9659 5.07176 10.3468C6.31831 7.72765 8.54612 5.69952 11.2771 4.69763C14.0081 3.69573 17.0246 3.79991 19.6794 4.98781M10.1545 35.9999H20.0402",
    stroke: "#1E434D",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.146 6.37735C28.6312 7.66024 29.4027 8.82241 30.4081 9.77292C31.2927 10.6092 32.3316 11.2565 33.4608 11.6828C32.3321 12.1094 31.2936 12.7567 30.4094 13.593C29.405 14.5429 28.6341 15.7041 28.1491 16.9858C27.6712 15.7094 26.9088 14.5516 25.9133 13.6028C25.0308 12.7617 23.9926 12.1121 22.8638 11.6842C23.9923 11.255 25.0295 10.6039 25.9107 9.76328C26.9064 8.81358 27.6686 7.65473 28.146 6.37735ZM21.1777 12.1463L21.178 12.1463L21.1777 12.1463Z",
    stroke: "#1E434D",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNti);
export default __webpack_public_path__ + "static/media/nti.6af1691896047ac1d896ff6754162f2b.svg";
export { ForwardRef as ReactComponent };